import { render, staticRenderFns } from "./PagesList.vue?vue&type=template&id=1e2c170d"
import script from "./PagesList.vue?vue&type=script&lang=js"
export * from "./PagesList.vue?vue&type=script&lang=js"
import style0 from "./PagesList.vue?vue&type=style&index=0&id=1e2c170d&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2c170d')) {
      api.createRecord('1e2c170d', component.options)
    } else {
      api.reload('1e2c170d', component.options)
    }
    module.hot.accept("./PagesList.vue?vue&type=template&id=1e2c170d", function () {
      api.rerender('1e2c170d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/PagesList.vue"
export default component.exports